import React,{Component} from "react";
import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/ReviewsAPI/create/`
})
const OrderApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/`
})

class Reviews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rating:0,
            hover:0,
            comment:null,
            test:null,
            flag:false,
        }
    } 
    onSubmit =async (event) => {
        event.preventDefault();
        (this.state.rating === 0 || this.state.comment=== null) ?
        this.setState({test:'Please Fill All Fields !'})
        :
        this.setState({test:'ok'})
        let data = new FormData();
        data.append('comment', this.state.comment);
        data.append('rating', this.state.rating);
        data.append('item', this.props.item);
        data.append('buyer', this.props.buyer);
        await api.post('/',data);
        this.setState({comment:null,rating:0})

        let data1 = new FormData();
        data1.append('status','completed' );
        await OrderApi.put(`OrdersAPI/${this.props.id}/`, data1);
        this.setState({flag:true})
    }
    render() {
    return(
    this.state.flag === false ?
    <>
    <form>
    <div className='pt-2 all-center'>
        {[ ...Array(5)].map((star, i) => {
            const ratingValue = i+1;
            return(
                <label>
                    <input type='radio' name='rating' style={{display:'none'}} value={ratingValue} onClick={()=> this.setState({rating:ratingValue})} required />
                    <i className='fa fa-star' 
                    style={{fontSize:'36px', color:ratingValue <= ( this.state.hover || this.state.rating ) ? '#ffc107' : '#e4e5e9'}} onMouseEnter={()=> this.setState({hover:ratingValue})} onMouseLeave={()=>this.setState({hover:0})} />
                </label>
            );
        })}
        
    </div>
    <div className='pt-3 all-center'>
        <textarea placeholder='Leave a comment here!' onChange={(e)=>this.setState({comment: e.target.value}) } value={this.state.comment} style={{height:'180px',width:'350px'}} required/>
    </div>
    <div className='pt-2 all-center'>
    <p style={{color:'red', fontSize:'12px'}}>{this.state.test === 'Please Fill All Fields !'? this.state.test : null}</p><br/>
    </div>
    <div className='pt-1 all-center'>
        <button className='btn btn-primary' type='submit' onClick={this.onSubmit}>Submit</button>
    </div>
    </form>
    </>
    : 
    <div className='pt-5 all-center'>
        <h2>Thanks for your Feedback!</h2>
    </div>
    
    )
}
} 
export default Reviews;